import { planBuilderProductConfigurationsSorted } from '../actions/PlanBuilderActions';
import { AllPlanBuilderActionTypes, PLAN_BUILDER_PRODUCT_CONFIGURATIONS_SORTED } from '../actions/constants/ActionTypes';
import { planBuilderProductConfigurationsSelector } from '../selectors/PlanBuilderSelectors';
import { sortedProductConfigurationsSelector } from '../selectors/ProductConfigsSelectors';

/**
 * Middleware to sort product configurations in PlanBuilder. This keeps the
 * order in the SummaryColumn the same as products are added/removed.
 *
 * This will run on every update/action in PlanBuilder (except for after its own action)
 */
export const sortProductConfigurationsMiddleware = store => next => action => {
  if (AllPlanBuilderActionTypes.includes(action.type) && PLAN_BUILDER_PRODUCT_CONFIGURATIONS_SORTED !== action.type) {
    // Commit the previous action's payload to state so we can access
    // the updated productConfigurations below
    next(action);
    const state = store.getState();
    const productConfigurations = planBuilderProductConfigurationsSelector(state);
    const sortedProductConfigurations = sortedProductConfigurationsSelector(state, {
      productConfigurations
    });
    store.dispatch(planBuilderProductConfigurationsSorted({
      productConfigurations: sortedProductConfigurations
    }));
    return;
  }
  return next(action);
};